const Base_Url = "https://api.millionairclubs.in/";
export default Base_Url;
